import React, { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm, useFieldArray } from 'react-hook-form';
import Loader from '../../shared/displayComponents/loader/Loader';
import CreatePlayerForm from '../createPlayer/CreatePlayerForm';
import { editPlayer } from './store/actions';
import { fetchPlayer } from '../store/actions';
import notFound from '../../assets/notFound.png';
import {
  playerAnalysisFeature,
  playerPhysicalFeature,
} from '../createPlayer/selectObjects';

const findPhysicalFeature = key =>
  playerPhysicalFeature.find(feature => feature.key === key);

const isPredefinedAnalysis = item => playerAnalysisFeature.includes(item);

const cleanCustom = values => values.map(value => value.trim()).filter(Boolean);

const EditPlayer = ({ match }) => {
  const { player } = useSelector(({ players }) => players);
  const { isLoading } = useSelector(({ shared }) => shared);

  const playerId = match.params.id;

  const { register, handleSubmit, errors, reset, watch, control } = useForm({
    defaultValues: {
      player,
    },
  });
  const { fields, append, prepend, remove } = useFieldArray({
    control,
    name: 'youtubeUrl',
  });

  const {
    fields: accomplishmentsFields,
    append: accomplishmentsAppend,
    remove: accomplishmentsRemove,
  } = useFieldArray({
    control,
    name: 'accomplishments',
  });

  const {
    fields: customPhysicalsFields,
    append: customPhysicalsAppend,
    remove: customPhysicalsRemove,
  } = useFieldArray({
    control,
    name: 'customPhysicals',
  });

  const {
    fields: customAnalysisFields,
    append: customAnalysisAppend,
    remove: customAnalysisRemove,
  } = useFieldArray({
    control,
    name: 'customAnalysis',
  });

  const selectedSport = watch('sport');
  const isTransfer = watch('transfer');
  const history = useHistory();
  const dispatch = useDispatch();
  const multiselectEnglishRef = useRef();
  const multiselectPhysicalsRef = useRef();
  const multiselectAnalysisRef = useRef();
  const multiSelectLevelOfPlayRef = useRef();
  const positionRef = useRef();

  useEffect(() => {
    dispatch(fetchPlayer(playerId));
  }, [dispatch, playerId]);

  useEffect(() => {
    const { image, ...newPlayer } = player;

    reset({
      ...newPlayer,
      ...image,
      customPhysicals: (newPlayer.physicals || []).filter(
        key => !findPhysicalFeature(key),
      ),
      customAnalysis: (newPlayer.analysis || []).filter(
        item => !isPredefinedAnalysis(item),
      ),
    });
  }, [player, reset]);

  const updatePlayer = ({
    image,
    customPhysicals = [],
    customAnalysis = [],
    ...playerToEdit
  }) => {
const analysis = multiselectAnalysisRef.current.getSelectedItems();
    const physicals = multiselectPhysicalsRef.current.getSelectedItems();
    const englishSkills = multiselectEnglishRef.current.getSelectedItems();
    const levelOfPlay = multiSelectLevelOfPlayRef.current.getSelectedItems();
    const position = positionRef.current.getSelectedItems();
    const formData = {
      formValues: {
        ...playerToEdit,
        englishSkills,
        physicals: [
          ...physicals.map(({ key }) => key),
          ...cleanCustom(customPhysicals),
        ],
        analysis: [...analysis, ...cleanCustom(customAnalysis)],
        levelOfPlay,
        position,
      },
      files: image,
    };
    dispatch(editPlayer(playerId, formData, history));
  };

  const physicalFeatures =
    player.physicals &&
    player.physicals.map(findPhysicalFeature).filter(Boolean);

  const analysisFeatures =
    player.analysis && player.analysis.filter(isPredefinedAnalysis);

  const checkIfPhotoExists = () => {
    if (player.image) {
      const buffer = player.image.data;
      const b64 = Buffer.from(buffer).toString('base64');
      return `data:image/jpeg;base64,${b64}`;
    }
    return notFound;
  };

  return isLoading ? (
    <Loader />
  ) : (
    <CreatePlayerForm
      fields={fields}
      append={append}
      prepend={prepend}
      remove={remove}
      multiselectAnalysisRef={multiselectAnalysisRef}
      multiselectPhysicalsRef={multiselectPhysicalsRef}
      multiselectEnglishRef={multiselectEnglishRef}
      multiSelectLevelOfPlayRef={multiSelectLevelOfPlayRef}
      selectedSport={selectedSport}
      isTransfer={isTransfer}
      checkIfPhotoExists={checkIfPhotoExists}
      physicalFeatures={physicalFeatures}
      analysisFeatures={analysisFeatures}
      player={player}
      isEditMode
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      updatePlayer={updatePlayer}
      accomplishmentsFields={accomplishmentsFields}
      accomplishmentsAppend={accomplishmentsAppend}
      accomplishmentsRemove={accomplishmentsRemove}
      customPhysicalsFields={customPhysicalsFields}
      customPhysicalsAppend={customPhysicalsAppend}
      customPhysicalsRemove={customPhysicalsRemove}
      customAnalysisFields={customAnalysisFields}
      customAnalysisAppend={customAnalysisAppend}
      customAnalysisRemove={customAnalysisRemove}
      positionRef={positionRef}
    />
  );
};

export default EditPlayer;
